<h2 trans>Custom Appearance</h2>
<p class="tab-description" trans>
  Fully customize your Biolink. Change background color or select gradients and images. Choose
  button style, text color, typeface and more.
</p>

<button
  mat-raised-button
  type="button"
  color="accent"
  class="save-button"
  [disabled]="(editor.loading$ | async) || editor.appearanceForm.pristine"
  (click)="editor.saveAppearance()"
  trans
>
  Save Changes
</button>

<h3 trans>Background</h3>
<div class="material-panel">
  <background-selector [formControl]="editor.appearanceForm.get('bgConfig')"></background-selector>
</div>

<biolink-editor-fonts></biolink-editor-fonts>
<biolink-editor-buttons></biolink-editor-buttons>
